import { render, staticRenderFns } from "./UploadXls.vue?vue&type=template&id=0d222b42"
import script from "./UploadXls.vue?vue&type=script&lang=js"
export * from "./UploadXls.vue?vue&type=script&lang=js"
import style0 from "./UploadXls.vue?vue&type=style&index=0&id=0d222b42&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports